import { defineMessages } from 'react-intl';

export default defineMessages({
  back: {
    id: 'app.containers.RouteAssignment.back',
    defaultMessage: 'Back to week schedule',
  },
  applications: {
    id: 'app.containers.RouteAssignment.applications',
    defaultMessage: 'Applications',
  },
  assignments: {
    id: 'app.containers.RouteAssignment.assignments',
    defaultMessage: 'Assignments',
  },
  leader: {
    id: 'app.containers.RouteAssignment.leader',
    defaultMessage: 'Leader',
  },
  disableTurn: {
    id: 'app.containers.RouteAssignment.disableTurn',
    defaultMessage: 'Disable Turn',
  },
  disablingTurn: {
    id: 'app.containers.RouteAssignment.disablingTurn',
    defaultMessage: 'Disabling turn...',
  },
  unassignAllPublishers: {
    id: 'app.containers.RouteAssignment.unassignAllPublishers',
    defaultMessage: 'Unassign all',
  },
  assignmentFailed: {
    id: 'app.containers.RouteAssignment.assignmentFailed',
    defaultMessage: 'Error. The publisher could not be assigned.',
  },
  unassignmentFailed: {
    id: 'app.containers.RouteAssignment.unassignmentFailed',
    defaultMessage: 'Error. The publisher could not be unassigned.',
  },
  upToDate: {
    id: 'app.containers.RouteAssignment.upToDate',
    defaultMessage: 'Synchronized',
  },
  pending: {
    id: 'app.containers.RouteAssignment.pending',
    defaultMessage: 'Synchronizing…',
  },
  preferThisRoute: {
    id: 'app.containers.RouteAssignment.preferThisRoute',
    defaultMessage: 'Prefer this route',
  },
  neutralTowardsThisRoute: {
    id: 'app.containers.RouteAssignment.neutralTowardsThisRoute',
    defaultMessage: 'Neutral towards this route',
  },
  preferNotToGoOnThisRoute: {
    id: 'app.containers.RouteAssignment.preferNotToGoOnThisRoute',
    defaultMessage: 'Prefer not to be assigned to this route',
  },
  assignPublisher: {
    id: 'app.containers.RouteAssignment.assignPublisher',
    defaultMessage: 'Assign {firstName} {lastName}',
  },
  removePublisherAssignment: {
    id: 'app.containers.RouteAssignment.removePublisherAssignment',
    defaultMessage: 'Remove assignment of {firstName} {lastName}',
  },
});
